import { render, staticRenderFns } from "./one.vue?vue&type=template&id=12a29f70&scoped=true"
import script from "./one.vue?vue&type=script&lang=js"
export * from "./one.vue?vue&type=script&lang=js"
import style0 from "./one.vue?vue&type=style&index=0&id=12a29f70&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a29f70",
  null
  
)

export default component.exports